import { object, string } from 'yup';

const FORGOT_PASSWORD_SCHEMA = object().shape({
  username: string().required('forgotten_password:required'),
});

export default FORGOT_PASSWORD_SCHEMA;
